export const PRESENCE_COLORS = [
  '#4A90E2',
  '#E67E22',
  '#27AE60',
  '#8E44AD',
  '#E74C3C',
  '#16A085',
  '#F39C12',
  '#2980B9',
  '#D35400',
  '#1ABC9C',
];

export const getPresenceColor = value => {
  const key = String(value || '');
  if (!key) return PRESENCE_COLORS[0];

  const total = key
    .split('')
    .reduce((sum, char, index) => sum + (index + 1) * char.charCodeAt(0), 0);

  return PRESENCE_COLORS[total % PRESENCE_COLORS.length];
};
